<template functional>
    <g>
        <path d="M15.253 12.5033L2.9062 0.150097L0.747578 2.31509L10.9358 12.5033L0.741211 22.6915L2.9062 24.8501L15.2594 12.5033H15.253Z" />
    </g>

</template>





<script>

    export default {

        name: 'ArrowIcon'

    }

</script>